<template>
    <v-form ref="form" v-model="valid">
            <v-row dense>
                <v-col v-if="!!master" cols="12" sm="12">
                    Master
                    <v-text-field
                        readonly
                        :value="`${master.name}`"
                        hide-details
                        filled
                        >
                    </v-text-field>
                </v-col>
                <v-col v-else cols="12" sm="12" v-show="showMaster">
                    Master
                    <v-select
                        :items="masterList"
                        :loading="isLoadingMasterList"
                        :disabled="isLoadingMasterList"
                        item-text="name"
                        item-value="id"
                        label="Master"
                        @change="changed('master_id', $event)"
                        v-model="fields.master_id"
                        :rules="rules.master_id"
                        hide-details="auto"
                        solo
                        >
                    </v-select>
                </v-col>
                <v-col v-if="!!comercializadora" cols="12" sm="12">
                    Comercializadora
                    <v-text-field
                        readonly
                        :value="`${comercializadora.name}`"
                        hide-details
                        filled
                        >
                    </v-text-field>
                </v-col>
                <v-col v-else cols="12" sm="12" v-show="showComercializadora">
                    Comercializadora
                    <v-select
                        :items="comercializadoraList"
                        :loading="isLoadingComercializadoraList"
                        :disabled="isLoadingComercializadoraList || !fields.master_id"
                        item-text="name"
                        item-value="id"
                        label="Comercializadora"
                        @change="changed('comercializadora_id', $event)"
                        v-model="fields.comercializadora_id"
                        :rules="rules.comercializadora_id"
                        hide-details="auto"
                        solo
                        >
                    </v-select>
                </v-col>
                
                <v-col v-if="!!grupo" cols="12" sm="12">
                    Grupo
                    <v-text-field
                        readonly
                        :value="`${grupo.name}`"
                        hide-details
                        filled
                        >
                    </v-text-field>
                </v-col>
                <v-col v-else cols="12" sm="12" v-show="showGrupo">
                    Grupo
                    <v-select
                        :items="grupoList"
                        :loading="isLoadingGrupoList"
                        :disabled="isLoadingGrupoList || !fields.comercializadora_id"
                        item-text="name"
                        item-value="id"
                        label="Grupo"
                        @change="changed('grupo_id', $event)"
                        v-model="fields.grupo_id"
                        :rules="rules.grupo_id"
                        hide-details="auto"
                        solo
                        >
                    </v-select>
                </v-col>
                <v-col cols="12" sm="8">
                    Nombre
                    <v-text-field
                        v-model="fields.name"
                        :rules="rules.name"
                        :disabled="loading"
                        label="Nombre"
                        solo
                        hide-details="auto"
                        @change="changed('name', $event)"
                        required
                        />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    Estado
                    <v-switch
                        v-model="fields.is_active"
                        :rules="rules.is_active"
                        :disabled="loading"
                        :label="fields.is_active ? 'Activo' : 'Inactivo'"
                        inset
                        hide-details="auto"
                        color="primary"
                        @change="changed('is_active', $event)"
                        required
                        />
                </v-col>
                <v-col cols="12">
                    Descripción
                    <v-textarea
                        v-model="fields.description"
                        :rules="rules.description"
                        :disabled="loading"
                        label="Descripción"
                        rows="5"
                        clearable
                        clear-icon="mdi-close-circle"
                        solo
                        hide-details="auto"
                        auto-grow
                        @change="changed('description', $event)"
                        />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-card outlined tile>
                        <v-card-title>Usuario</v-card-title>
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    Nombre de Usuario
                                    <v-text-field
                                        v-model="fields.username"
                                        :rules="rules.username"
                                        :disabled="loading"
                                        label="Nombre de Usuario"
                                        solo
                                        hide-details="auto"
                                        @change="changed('username', $event)"
                                        required
                                        />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    Contraseña
                                    <v-text-field
                                        v-model="fields.password"
                                        type="password"
                                        :rules="rules.password"
                                        :disabled="loading"
                                        autocomplete="new-password"
                                        label="Contraseña"
                                        clearable
                                        solo
                                        hide-details="auto"
                                        @change="changed('password', $event)"
                                        />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
    </v-form>
</template>
<script>
import Form from '@mixins/form';

import MasterService from '@services/comercio/MasterService';
import ComercializadoraService from '@services/comercio/ComercializadoraService';
import GrupoService from '@services/comercio/GrupoService';

export default {
    mixins: [Form],
    props: ['master', 'comercializadora', 'grupo'],
    data: function () {
        return {
            defaultFields: {
                name: null,
                description: null,
                master_id: null,
                comercializadora_id: null,
                grupo_id: null,
                is_active: true,
                username: null,
                password: null,
            },

            masterList: [],
            showMaster: true,
            isLoadingMasterList: false,

            comercializadoraList: [],
            showComercializadora: true,
            isLoadingComercializadoraList: false,

            grupoList: [],
            showGrupo: true,
            isLoadingGrupoList: false,
        };
    },
    computed: {
        rules: function () {
            return {
                name: [v => !!v || 'El nombre de la Agencia no puede estar vacío'],
                comercializadora_id: [v => !!v || 'Seleccione una Comercializadora'],
                master_id: [v => !!v || 'Seleccione un Master'],
                grupo_id: [v => !!v || 'Seleccione un grupo'],
                description: [],
                is_active: [],
                username: [v => !!v || 'El Usuario no puede estar vacío'],
                password:  this.default?.username ? [] : [v => !!v || 'Introduzca la contraseña'],
            }
        }
    },
    created: function () {
        this.getMasterList();
    },
    mounted: function () {
        if (this.fields.master_id) {
            this.getComercializadoraList();
        }
        if (this.fields.comercializadora_id) {
            this.getGrupoList();
        }
    },
    methods: {
        getMasterList: function () {
            this.isLoadingMasterList = true;

            this.masterList = [];
            this.comercializadoraList = [];

            MasterService
                .getList({ is_active: true })
                .then(({ masterList }) => { 
                    if (masterList.length == 1) {
                        this.fields.master_id = masterList[0].id;
                        this.showMaster = false;
                    }
                    this.masterList = masterList; 
                })
                .finally(() => this.isLoadingMasterList = false);
        },
        getComercializadoraList: function () {
            this.comercializadoraList = [];
            if (!this.fields.master_id) return;

            this.isLoadingComercializadoraList = true;

            ComercializadoraService
                .getList({ is_active: true, master_id: this.fields.master_id })
                .then(({ comercializadoraList }) => { 
                    if (comercializadoraList.length == 1) 
                    {
                        this.fields.comercializadora_id = comercializadoraList[0].id;
                        this.showComercializadora = false;
                    }
                    this.comercializadoraList = comercializadoraList; 
                })
                .finally(() => this.isLoadingComercializadoraList = false);
        },
        getGrupoList: function () {
            this.grupoList = [];
            if (!this.fields.comercializadora_id) return;

            this.isLoadingGrupoList = true;

            GrupoService
                .getList({ is_active: true, comercializadora_id: this.fields.comercializadora_id })
                .then(({ grupoList }) => { 
                    if (grupoList.length == 1) 
                    {
                        this.fields.grupo_id = grupoList[0].id;
                        this.showGrupo = false;
                    }
                    this.grupoList = grupoList; 
                })
                .finally(() => this.isLoadingGrupoList = false);
        },
        onChange: function (field) {
            switch(field) {
                case 'master_id':
                    this.fields.comercializadora_id = null;   
                break;
                case 'comercializadora_id':
                    this.fields.grupo_id = null;   
                break;
            }
        }
    },
    watch: {
        'fields.master_id': function () {
            this.showComercializadora = true;
            this.getComercializadoraList();
        },
        'fields.comercializadora_id': function () {
            this.showGrupo = true;
            this.getGrupoList();
        },
    }
}
</script>